import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./config/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { AppProvider } from "./config/AppContext";
import {
  CustomError,
  CustomSuccess,
  CustomWarning,
} from "./notification/NotificationStyle";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <SnackbarProvider
        maxSnack={8} // Wrap App with SnackbarProvider
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Customize position
        autoHideDuration={3000}
        Components={{
          success: CustomSuccess,
          error: CustomError,
          warning: CustomWarning,
        }}
      >
        <AppProvider>
          <App />
        </AppProvider>{" "}
      </SnackbarProvider>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
